import { type ConfigEnvironment } from "./environment";

export enum ConfigApp {
  admin = "admin",
  cms = "cms",
  wallView = "wallView",
}

export const CONFIG_APP_TO_DISPLAY_NAME: { [key in ConfigApp]: string } = {
  admin: "Admin",
  cms: "CMS",
  wallView: "Wall View",
};

export const CONFIG_QRCODE_APP_URL_BY_ENVIRONMENT: {
  [key in ConfigEnvironment]: string;
} = {
  dev: "https://qrcode-dev.panoscape.app",
  local: "http://localhost:3004",
  prod: "https://qrcode.panoscape.app",
};
